import React from 'react';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManagePaymentLogsComponent from '@app/components/manage-payment-logs/list';

const ManagePaymentLogs: React.FC = () => {
  return (
    <>
      <PageTitle>Payment Audit Logs</PageTitle>
      <ManagePaymentLogsComponent />
    </>
  );
};

export default ManagePaymentLogs;
